// extracted by mini-css-extract-plugin
module.exports = {"background-image":"DonationCampaignBannerSection_background-image__H29b3","banner-container":"DonationCampaignBannerSection_banner-container__3Kf3v"};